import { render, staticRenderFns } from "./WeldControl.vue?vue&type=template&id=34f362d4&scoped=true"
import script from "./WeldControl.vue?vue&type=script&lang=js"
export * from "./WeldControl.vue?vue&type=script&lang=js"
import style0 from "./WeldControl.vue?vue&type=style&index=0&id=34f362d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f362d4",
  null
  
)

export default component.exports